module.exports = __webpack_public_path__ + "img/puzzle_19.e561b378.png";